import React from "react";
import "./registrationform.css"; // Ensure you have this CSS for styling
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

export default function RegistrationCompleted({ logOut, appId, fullName }) {
  const redirect = useNavigate();
  const Applicant = useSelector(
    (state) => state.admissionActions.queue.Applicant
  );

  return (
    <section className="fx-ac fx-jc" style={{ height: "100vh" }}>
      <div
        className="errCont fx-cl fx-ac space2"
        style={{ backgroundColor: "#fafaff" }}
      >
        <h3>🎉 Success!</h3>
        <p>Your application has been submitted successfully!</p>
        <p>You can click on the button below to check your admission status</p>
        <div className="fx-jc space3">
          <button onClick={() => redirect("/")}>Close</button>

          <button
            style={{ backgroundColor: "#18c07a" }}
            onClick={() => redirect("/admission_status")}
          >
            Check status
          </button>
        </div>
      </div>
    </section>
  );
}
